import { useTicket } from "Hooks/Endpoints";
import { Container } from "semantic-ui-react";
import TicketDetail from "./TicketDetail";
import TicketListHolder from "./TicketListHolder";

const TicketView = () => {
  const {
    tickets,
    ticket,
    create,
    unselect,
    openTicket,
    closeTicket,
    pendingTicket,
    updateEmails,
    addNote,
    addComment,
  } = useTicket();
  return (
    <Container fluid>
      {tickets && !ticket && !create && <TicketListHolder />}
      {ticket && !create && (
        <TicketDetail
          ticket={ticket}
          unselect={unselect}
          openTicket={openTicket}
          closeTicket={closeTicket}
          pendingTicket={pendingTicket}
          updateEmails={updateEmails}
          addNote={addNote}
          addComment={addComment}
        />
      )}
    </Container>
  );
};

export default TicketView;
